const API_VERSION = (import.meta.env.VITE_API_VERSION as string) ?? "v1";
const APP_BACKEND_URL = (import.meta.env.VITE_APP_BACKEND_URL as string) ?? "";

export interface ContactPayload {
  name: string;
  email: string;
  phone?: string;
  subject: string;
  message: string;
}

export type ContactResult =
  | { ok: true }
  | { ok: false; status: number; error: string };

export async function submitContactForm(
  payload: ContactPayload
): Promise<ContactResult> {
  try {
    const res = await fetch(`${APP_BACKEND_URL}/${API_VERSION}/contact`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ ...payload, hp: "" }),
    });
    if (res.ok) return { ok: true };
    let error = "Error desconocido";
    try {
      const json = (await res.json()) as { error?: string };
      if (typeof json.error === "string") error = json.error;
    } catch {
      // ignore JSON parse errors
    }
    return { ok: false, status: res.status, error };
  } catch {
    return { ok: false, status: 0, error: "Network error" };
  }
}
